import { REST_URL } from '@/lib/env';

export async function uploadAvatarImage(blob: Blob, uid: string): Promise<string> {
  const ext = blob.type === 'image/png' ? 'png' : 'jpg';
  const filename = `avatar-${uid}-${Date.now()}.${ext}`;
  const base = REST_URL.endsWith('/') ? REST_URL : `${REST_URL}/`;
  const res = await fetch(`${base}images/${filename}`, {
    method: 'PUT',
    headers: { 'Content-Type': blob.type || 'image/jpeg' },
    credentials: 'include',
    body: blob,
  });
  if (!res.ok) throw new Error('avatar_upload_failed');
  const { url } = (await res.json()) as { url: string };
  return url;
}
